import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const Navbar = () => {
  return (
    <header className="navbar">
      <Link to="/" className="navbar-brand">
        <Logo size={40} />
        <h1>Procure<span>ForEU</span></h1>
        </Link>
      <nav className="nav-links">
        <a href="#about">About</a>
        <a href="#why">Why</a>
        <a href="#start-free">Start free</a>
        <a href="#partners">Partners</a>
        <a href="#values">Values</a>
        <a href="#quote">Contact</a>
      </nav>
    </header>
  );
};

export default Navbar;